module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD1SURBVHgB7daxCcMwEIXhiwrPoVW8iSvjkVx6E48SjWFciOhB0oQU4XTvDOZ+EFL5Ia44kSiKolv1EGXzPD9xn+c5bttWxKkkfeVhGPZpmrI4pQanlMZ2FXFGq0cCLcuSa617e+Z2isd4dIGRN7objDzRJmDkhTYDIw+0KRix0eZgxERTwIiFpoERA00FI2s0HYws0b3Lz1+t61q+dw9R5gJGx3GIRS5gbHLvX83tfH5bFX2Gf2ExIqKMCrbGIhqYgUUUMAuLzMFMLDIFs7HIDOyBRSZgLyzqBntiURfYG4vU4CuwSL1LXIFFvcuPKzaKouiGvQA90uc+ippl/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back-r.png
// module id = 5KwQ
// module chunks = 0